import React from "react";
import JoinAERA from "../../components/JoinAERA/JoinAERA";

const JoinAERAPage = () => {
  return <JoinAERA />;
};

export default JoinAERAPage;
